import { Flex, Text, Icon, Tooltip } from '@chakra-ui/react';
import React, { useState } from 'react';
import webApp from '@happylife-a/web-app';
import webCore from '@happylife-a/web-core';

export default function AddressCoordinates({ address }) {
  const { t } = webCore.contexts.useTranslation();

  const [copySuccess, setCopySuccess] = useState(t('Copy'));

  const copyToClipboard = () => {
    const textToCopy = `${address?.latitude} ${address?.longitude}`;
    navigator.clipboard.writeText(textToCopy).then(() => {
      setCopySuccess(t('Copied'));
      setTimeout(() => setCopySuccess(t('Copy')), 2000);
    });
  };

  return (
    <Flex flexDir="row" align="center">
      <Text variant="body-med" color="gray.900">
        {address?.latitude} {address?.longitude}
      </Text>
      <Tooltip label={copySuccess} closeOnClick={false} bg="black.50">
        <Icon
          as={webApp.theme.icons.Copy}
          color={webApp.theme.colors.primary[500]}
          w={4}
          h={6}
          ml={3}
          cursor="pointer"
          onClick={copyToClipboard}
        />
      </Tooltip>
    </Flex>
  );
}
